module.exports = __webpack_public_path__ + "static/media/40-points.76a7cd66.png";